import { render } from "./EducationBlock.vue?vue&type=template&id=705f6198&scoped=true"
import script from "./EducationBlock.vue?vue&type=script&lang=js"
export * from "./EducationBlock.vue?vue&type=script&lang=js"

import "./EducationBlock.vue?vue&type=style&index=0&id=705f6198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705f6198"]])

export default __exports__